import React from 'react';
import { Card, Container, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { APIENV, getCustomiserState } from '@europrocurement/l2d-domain';
import { usePaiementApi } from '../../../hooks/usePaiementApi';
import { L2DPLogoIcon } from '../L2DPLogoIcon/L2DPLogoIcon';
import { L2DRLogoIcon } from '../L2DRLogoIcon/L2DRLogoIcon';

export type PostPaiementType = {
    valide: boolean;
    type?: 'recouvrement' | 'paiement';
};
const PostPaiement: React.FunctionComponent<PostPaiementType> = function ({
    valide,
    type = 'paiement',
}) {
    const { env } = usePaiementApi();

    const l2dContact = () =>
        APIENV.apps.l2dcontact[getCustomiserState().app.l2dcontact] || undefined;
    return (
        <Container>
            {env !== 'prod' ? (
                <Box
                    id="env-ribbon"
                    className={`${env}`}
                >
                    {env}
                </Box>
            ) : null}
            <Box sx={{ textAlign: 'center' }}>
                {type === 'paiement' ? <L2DPLogoIcon /> : <L2DRLogoIcon />}
            </Box>{' '}
            {valide ? (
                <Card
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                    }}
                >
                    <Typography variant="l2dh6">
                        Votre paiement a été validé avec succès.
                    </Typography>
                    <Typography variant="l2dh6">
                        Pour toute question, notre équipe reste à votre disposition via{' '}
                        {l2dContact() ? (
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={l2dContact()}
                            >
                                notre formulaire de contact
                            </a>
                        ) : (
                            'notre formulaire de contact'
                        )}
                        .
                    </Typography>
                </Card>
            ) : (
                <Card
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                    }}
                >
                    <Typography variant="l2dh6">
                        Votre transaction a été refusée ou interrompue.
                    </Typography>
                    <Typography variant="l2dh6">Aucun montant n’a été débité.</Typography>
                    <Typography variant="l2dh6">
                        Merci de vérifier les informations de votre carte ou d’essayer un autre mode
                        de paiement.
                    </Typography>
                    <Typography variant="l2dh6">
                        Si le problème persiste,{' '}
                        {l2dContact() ? (
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={l2dContact()}
                            >
                                contactez notre support
                            </a>
                        ) : (
                            'contactez notre support'
                        )}{' '}
                        pour obtenir de l’aide.
                    </Typography>
                </Card>
            )}
        </Container>
    );
};
export default PostPaiement;
